export const GET_ATTENDANCE = 'GET_ATTENDANCE'
export const GET_ATTENDANCE_SUCCESS = 'GET_ATTENDANCE_SUCCESS'

export const GET_VISITS = 'GET_VISITS'
export const GET_VISITS_SUCCESS = 'GET_VISITS_SUCCESS'